import Repository from "./Repository";

const resource = "";
export default {
  /**
   * 浸水想定区域一覧取得
   * @param towns 市町村リスト
   */
  getInundations(towns) {
    return Repository.get(`${resource}/inu/` + towns);
  },
  /**
   * ハザードマップ一覧取得
   * @param towns 市町村リスト
   */
  getHazardMap(towns) {
    return Repository.get(`${resource}/hzd/` + towns);
  },
};
